import React from 'react';
import { Typography } from '@mui/material';
import Icon from '@mdi/react';
import { mdiAlertCircle } from '@mdi/js';

interface ErrorsMessagesComponentProps {
	errorsList: string[];
}

export function ErrorsMessagesComponent({ errorsList }: ErrorsMessagesComponentProps) {
	return (
		<div
			aria-label="errorList"
			style={{
				marginTop: 8,
				padding: '24px 32px',
				border: '1px solid #f5c2c7',
				backgroundColor: '#fef2f2',
				borderRadius: 8,
				display: 'flex',
				flexDirection: 'column',
				gap: 12,
				maxWidth: '100%',
				marginRight: 18,
				marginLeft: 18,
			}}
		>
			{errorsList.map((errorMessage, index) => (
				<div
					key={index}
					style={{
						display: 'flex',
						alignItems: 'flex-start',
						gap: 8,
						color: '#d32f2f',
					}}
				>
					<Icon path={mdiAlertCircle} size="20px" />
					<Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
						{errorMessage}
					</Typography>
				</div>
			))}
		</div>
	);
}
